export default
{
    ARTICLE: {
        PROPERTIES_UPDATED: 'ARTICLE.PROPERTIES_UPDATED'
    /* Wird ausgelöst, wenn nach einer Größen-/Farbauswahl ein Artikel upgedated wurde
                    * - {
                    *      "context": Kontext, beispielsweise wishlist (warenkorb denkbar)
                    *      "digistyleId": Integer // Digistyle-ID des Artikels auf dem Layer
                    *   }
                    */
    },
    WISHLIST: {
        ITEM_DELETED: 'WISHLIST.ITEM_DELETED'
    , /* Wird ausgelöst, wenn ein Wunschlisten-Eintrag aus der Wunschliste gelöscht wird.
                     * - {
                     *      "currentItemsInWishlist": Integer (optional),      // Aktuelle Anzahl der Wunschlisteneinträge
                     *      "digistyleId": Integer (optional)                  // Digistyle-ID des Artikels
                     *   }
                     */
        ITEM_ADDED: 'WISHLIST.ITEM_ADDED'
    , /* Wird ausgelöst, wenn ein Wunschlisten-Eintrag in die Wunschliste hinzugefügt wird.
                     * - {
                     *      "amountAdded": Integer,                  // Anzahl hinzugekommener Items
                     *      "digistyleId": Integer,                  // DigistyleId des hinzugefügten Artikels
                     *    }
                     */
        OPEN_CHANGE_ITEM_ONSITE_ELEMENT: 'WISHLIST.OPEN_CHANGE_ITEM_ONSITE_ELEMENT'
    , /* Wird ausgelöst, wenn das Change-Item-Onsite-Element aufgerufen werden soll
                    * - {
                    *        "type": ["cart", "change"], // Bestimmt den Typ des Submit Buttons im Onsite Element
                    *        "styleId": Integer,      // DigistyleID (grob: Variante) des zu editierenden Produkts
                    *        "itemId": Integer,       // ItemID (Farbe) des zu editierenden Produkts
                    *        "itemOptionId": Integer, // ItemOptionID (Größe) des zu editierenden Produkts
                    *        "shopId": Integer,       // ShopID des zu editierenden Produkts
                    *        "wishlistItemId": Integer, // Wishlist Item ID des zu editierenden Eintrags
                    *        "wishlistItem": Element, // Wishlist-Item, das angeklickt wurde
                    *        "wishlistItemIndex": Integer, // Index des Wishlist-Items in der Liste
                    *   }
                    */
        CLOSE_CHANGE_ITEM_ONSITE_ELEMENT: 'WISHLIST.CLOSE_CHANGE_ITEM_ONSITE_ELEMENT'
        , /* Wird ausgelöst, wenn das Change-Item-Onsite-Element geschlossen werden soll */
        TOGGLE_CHANGE_ITEM_ONSITE_ELEMENT: 'WISHLIST.TOGGLE_CHANGE_ITEM_ONSITE_ELEMENT'
        , /* Wird ausgelöst, wenn von Außen der Zustand der ButtonBar bezüglich des ChangeItem geändert werden soll
                                               * (Öffnen und Schließen des Change-Layers von außen)
                                               * - {
                                               *        "sourceEvent": event,      // Click-Event des Auslösers um das Auslösende Element zu ermitteln
                                               *        "itemIndex": Integer,      // Index der Position auf der Wunschliste
                                               *   }
                                               */
        ADD_TO_CART_ERROR: 'ADD_TO_CART_ERROR'
        /* Wird ausgelöst, wenn es einen Fehler beim Hinzufügen in den Warenkorb gab */
    ,
        CHANGE_LAYER_ITEM_INDEX_UPDATE: 'WISHLIST.CHANGE_LAYER_ITEM_STYLE_UPDATE'
    ,
        CHANGE_LAYER_STYLE_INDEX_UPDATE: 'WISHLIST.CHANGE_LAYER_STYLE_INDEX_UPDATE'
    ,
        CHANGE_LAYER_ITEMOPTION_INDEX_UPDATE: 'WISHLIST.CHANGE_LAYER_ITEMOPTION_INDEX_UPDATE'
    ,
        ITEM_COUNT_CHANGED: 'WISHLIST.ITEM_COUNT_CHANGED'
    ,
        SORTING_CHANGE: 'WISHLIST.SORTING_CHANGE'
    },
    CART: {
        OPEN_CHANGE_ITEM_ONSITE_ELEMENT: 'CART.OPEN_CHANGE_ITEM_ONSITE_ELEMENT',
        CLOSE_CHANGE_ITEM_ONSITE_ELEMENT: 'CART.CLOSE_CHANGE_ITEM_ONSITE_ELEMENT'
    }
};
